<template>
  <svg
    :width="smallIcon ? 13 : 20"
    :height="smallIcon ? 13 : 20"
    viewBox="0 0 25 25"
    :class="{ 'own-goal': isOwnGoal, 'mpg-goal': isMpgGoal }"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  ><path
     d="M18.4285 11.9849V12.1016C18.3696 13.7737 17.6615 15.3571 16.4545 16.5158C15.2475 17.6746 13.6365 18.3174 11.9633 18.308C10.2902 18.2986 8.68651 17.6377 7.49259 16.4654C6.29867 15.2932 5.60844 13.7019 5.56836 12.0292C5.56836 12.0137 5.56836 11.9981 5.56836 11.9826C5.56836 10.2764 6.24612 8.64016 7.45254 7.43374C8.65896 6.22732 10.2952 5.54956 12.0014 5.54956C13.7075 5.54956 15.3438 6.22732 16.5502 7.43374C17.7566 8.64016 18.4344 10.2764 18.4344 11.9826L18.4285 11.9849Z"
     fill="white"
     stroke-width="0.644"
     stroke-miterlimit="10"
   /><path
     d="M12.0455 9.76477L14.2003 11.3304L13.3766 13.8621H10.7143L9.89062 11.3304L12.0455 9.76477Z"
     class="filled"
     stroke-width="0.752"
     stroke-miterlimit="10"
   /><path
     d="M14.2003 6.04425L12.0455 7.61108L9.89062 6.04425L9.94313 5.89142C11.3134 5.43118 12.7984 5.44391 14.1606 5.92758L14.2003 6.04425Z"
     class="filled"
     stroke-width="0.752"
     stroke-miterlimit="10"
   /><path
     d="M7.9192 10.6083L5.76437 12.1739L5.56837 12.0304V11.9838C5.56616 10.5705 6.03175 9.1963 6.89253 8.07544H7.0967L7.9192 10.6083Z"
     class="filled"
     stroke-width="0.752"
     stroke-miterlimit="10"
   /><path
     d="M10.3192 17.9921L10.1197 18.1367C8.76022 17.72 7.57678 16.8651 6.75391 15.7054L6.83324 15.4592H9.49557L10.3192 17.9921Z"
     class="filled"
     stroke-width="0.752"
     stroke-miterlimit="10"
   /><path
     d="M17.3097 15.6156C16.5003 16.8025 15.3172 17.6847 13.9485 18.1216L13.7759 17.9967L14.5984 15.4592H17.2607L17.3097 15.6156Z"
     class="filled"
     stroke-width="0.752"
     stroke-miterlimit="10"
   /><path
     d="M18.4334 11.9849V12.1016L18.3272 12.1786L16.1724 10.6083L16.996 8.07544H17.1127C17.9735 9.1963 18.4391 10.5705 18.4369 11.9838L18.4334 11.9849Z"
     class="filled"
     stroke="#696773"
     stroke-width="0.752"
     stroke-miterlimit="10"
   /><path
     d="M12.0913 9.71929V7.63562"
     stroke-width="0.644"
     stroke-miterlimit="10"
     stroke-linecap="square"
   /><path
     d="M14.1748 11.3502L16.1686 10.6257"
     stroke-width="0.644"
     stroke-miterlimit="10"
     stroke-linecap="square"
   /><path
     d="M13.3594 13.8877L14.6275 15.4277"
     stroke-width="0.644"
     stroke-miterlimit="10"
     stroke-linecap="square"
   /><path
     d="M10.732 13.8877L9.46387 15.4277"
     stroke-width="0.644"
     stroke-miterlimit="10"
     stroke-linecap="square"
   /><path
     d="M9.91668 11.3502L7.92285 10.6257"
     stroke-width="0.644"
     stroke-miterlimit="10"
     stroke-linecap="square"
   />
    <path
      v-if="isSaved"
      class="hand-save"
      d="M20.5702 8.25001C20.4131 8.24935 20.2574 8.27981 20.1121 8.33963C19.9668 8.39945 19.8348 8.48744 19.7237 8.59854C19.6126 8.70964 19.5246 8.84164 19.4648 8.98692C19.405 9.13221 19.3745 9.2879 19.3752 9.44501V12H19.1412V6.83801C19.1418 6.6809 19.1114 6.52521 19.0516 6.37992C18.9917 6.23464 18.9037 6.10264 18.7926 5.99154C18.6816 5.88045 18.5496 5.79245 18.4043 5.73263C18.259 5.67281 18.1033 5.64235 17.9462 5.64301C17.639 5.64825 17.3462 5.77391 17.1307 5.99292C16.9152 6.21193 16.7944 6.50678 16.7942 6.81401V12H16.5632V5.70001C16.5645 5.54248 16.5345 5.38625 16.475 5.24038C16.4155 5.09452 16.3276 4.96193 16.2164 4.8503C16.1053 4.73867 15.973 4.65023 15.8274 4.59009C15.6818 4.52996 15.5257 4.49934 15.3682 4.50001C15.0614 4.50603 14.7691 4.63217 14.5543 4.85131C14.3394 5.07045 14.2191 5.36512 14.2192 5.67201V12H13.9852V6.86701C13.9858 6.71023 13.9555 6.55487 13.8959 6.40985C13.8364 6.26483 13.7487 6.13301 13.6381 6.02197C13.5274 5.91092 13.3959 5.82284 13.251 5.76278C13.1062 5.70273 12.951 5.67188 12.7942 5.67201C12.4867 5.677 12.1934 5.80267 11.9777 6.02193C11.762 6.24118 11.6411 6.53644 11.6412 6.84401V13.757L10.7142 12.483C10.5313 12.2311 10.2558 12.0621 9.9484 12.0132C9.6409 11.9644 9.3266 12.0396 9.0747 12.2225C8.82273 12.4054 8.65373 12.6808 8.60488 12.9883C8.55603 13.2958 8.63131 13.6101 8.81418 13.862L12.4942 18.922C12.6251 19.1017 12.7968 19.2478 12.9952 19.3483C13.1935 19.4487 13.4128 19.5007 13.6352 19.5H19.4242C19.7413 19.5003 20.0493 19.3934 20.298 19.1966C20.5467 18.9998 20.7215 18.7247 20.7942 18.416L21.5712 15.116C21.6707 14.6939 21.721 14.2617 21.7212 13.828V9.42801C21.7228 9.11974 21.6029 8.82325 21.3875 8.60276C21.172 8.38226 20.8784 8.25553 20.5702 8.25001Z"
      fill="white"
    />
    <path
      v-if="isCanceled"
      d="M13.8782 11.9989L19.606 6.28357C19.8568 6.03271 19.9977 5.69246 19.9977 5.33769C19.9977 4.98291 19.8568 4.64266 19.606 4.3918C19.3552 4.14093 19.015 4 18.6602 4C18.3055 4 17.9653 4.14093 17.7145 4.3918L12 10.1204L6.28552 4.3918C6.03469 4.14093 5.6945 4 5.33977 4C4.98504 4 4.64485 4.14093 4.39402 4.3918C4.14319 4.64266 4.00227 4.98291 4.00227 5.33769C4.00227 5.69246 4.14319 6.03271 4.39402 6.28357L10.1218 11.9989L4.39402 17.7142C4.26917 17.838 4.17007 17.9853 4.10244 18.1477C4.03482 18.31 4 18.4842 4 18.66C4 18.8359 4.03482 19.01 4.10244 19.1724C4.17007 19.3347 4.26917 19.4821 4.39402 19.6059C4.51785 19.7308 4.66517 19.8299 4.8275 19.8975C4.98982 19.9652 5.16392 20 5.33977 20C5.51562 20 5.68972 19.9652 5.85204 19.8975C6.01437 19.8299 6.16169 19.7308 6.28552 19.6059L12 13.8773L17.7145 19.6059C17.8383 19.7308 17.9856 19.8299 18.148 19.8975C18.3103 19.9652 18.4844 20 18.6602 20C18.8361 20 19.0102 19.9652 19.1725 19.8975C19.3348 19.8299 19.4822 19.7308 19.606 19.6059C19.7308 19.4821 19.8299 19.3347 19.8976 19.1724C19.9652 19.01 20 18.8359 20 18.66C20 18.4842 19.9652 18.31 19.8976 18.1477C19.8299 17.9853 19.7308 17.838 19.606 17.7142L13.8782 11.9989Z"
      fill="#E81E29"
    />
  </svg>
</template>

<script setup>

defineProps({
  isSaved: {
    type: Boolean,
    default: false,
  },
  isMpgGoal: {
    type: Boolean,
    default: false,
  },
  isOwnGoal: {
    type: Boolean,
    default: false,
  },
  isCanceled: {
    type: Boolean,
    default: false,
  },
  smallIcon: {
    type: Boolean,
    default: false,
  },
});
</script>

<style lang="scss" scoped>
path {
  stroke: #696773;
  &.filled {
    fill: #696773;
  }
  &.hand-save {
    stroke: #EF1728;
  }
}

.mpg-goal {
  path {
    stroke: #45C945;
    &.filled {
      fill: #45C945;
    }
  }
}
.own-goal {
  path {
    stroke: #E81E29;
    &.filled {
      fill: #E81E29;
    }
  }
}
</style>